import { Validator } from 'vee-validate';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import template from './accountDetail.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class AccountDetail extends Vue {
    // Properties
    @Prop()
    accountInfo: any;
    @Inject()
    $validator: Validator;
    // life cycle methods
    created() {}

    mounted() {}
    @Prop()
    index: number;

    @Prop()
    totalNum: number;

    deleteAccountLine(index: number) {
        // clear validation error bag
        this.$validator.errors.clear();
        this.$store.dispatch('deleteAccountLine', index);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/accountDetail/index.ts